module.exports = __webpack_public_path__ + "img/study_icon_gray@2x.3b9d6ae8.png";